// File: components/index.js
// Purpose: Barrel file exporting primary layout components for easy imports.
// Notes: Import this file when you need Header/Main/Footer collectively.
export { default as Header } from "./header";
export { default as Nav } from "./nav";
export { default as Main } from "./main";
export { default as Footer } from "./footer";

